import React from 'react';
import Svg, { Path } from 'react-native-svg';
import { CustomSVGProps, getBaseSVGProps } from './utils';

const Portals: React.FC<CustomSVGProps> = (props) => {
    return (
        <Svg {...getBaseSVGProps(props, 45)} fill="none">
            <Path
                d="M21.5 38C28.4036 38 34 32.4036 34 25.5C34 18.5964 28.4036 13 21.5 13C14.5964 13 9 18.5964 9 25.5C9 32.4036 14.5964 38 21.5 38Z"
                stroke={props.color}
                strokeDasharray="2 2"
            />
            <Path d="M22 17.4266V7.52734" stroke={props.color} strokeLinecap="round" strokeLinejoin="round" />
            <Path
                d="M22.0703 9.10747C24.3182 9.10747 26.1406 7.29255 26.1406 5.05373C26.1406 2.81492 24.3182 1 22.0703 1C19.8223 1 18 2.81492 18 5.05373C18 7.29255 19.8223 9.10747 22.0703 9.10747Z"
                fill="#fff"
                stroke={props.color}
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <Path d="M28 31.0007L35.8412 37.043" stroke="#4D6692" strokeLinecap="round" strokeLinejoin="round" />
            <Path
                d="M34.5468 36.1329C33.1747 37.9136 33.5 40.4648 35.2734 41.8314C37.0467 43.1979 39.5967 42.8622 40.9688 41.0815C42.3409 39.3009 42.0156 36.7496 40.2422 35.3831C38.4688 34.0166 35.9189 34.3523 34.5468 36.1329Z"
                fill="#fff"
                stroke={props.color}
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <Path d="M15.4533 31.0007L7.612 37.043" stroke="#4D6692" strokeLinecap="round" strokeLinejoin="round" />
            <Path
                d="M8.90649 36.1329C10.2786 37.9136 9.95328 40.4648 8.17989 41.8314C6.4065 43.1979 3.85657 42.8622 2.48447 41.0815C1.11237 39.3009 1.43768 36.7496 3.21107 35.3831C4.98446 34.0166 7.53439 34.3523 8.90649 36.1329Z"
                fill="#fff"
                stroke={props.color}
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <Path
                d="M21.5 34C26.1944 34 30 30.1944 30 25.5C30 20.8056 26.1944 17 21.5 17C16.8056 17 13 20.8056 13 25.5C13 30.1944 16.8056 34 21.5 34Z"
                fill="#fff"
                stroke={props.color}
                strokeWidth="2"
            />
        </Svg>
    );
};

export default React.memo(Portals);
